import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { getConversationsQueryKey } from "../lib/conversationsQuery"

type Params = {
  customerId: string
}

type Props = {
  params: Params
}

export function useDeletePastFakeConversationsMutation({ params }: Props) {
  const { customerId } = params
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      const response = await axios.delete(`/conversations/testing/${customerId}`)

      await queryClient.invalidateQueries({ queryKey: getConversationsQueryKey() })

      return response.data
    },
  })
}
